import { render, staticRenderFns } from "./TemplateFragen.vue?vue&type=template&id=175aac48"
import script from "./TemplateFragen.vue?vue&type=script&lang=js"
export * from "./TemplateFragen.vue?vue&type=script&lang=js"
import style0 from "./TemplateFragen.vue?vue&type=style&index=0&id=175aac48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports